import { render, staticRenderFns } from "./TableAutorizacionDeclaraciones.vue?vue&type=template&id=205f4100&scoped=true&"
import script from "./TableAutorizacionDeclaraciones.vue?vue&type=script&lang=js&"
export * from "./TableAutorizacionDeclaraciones.vue?vue&type=script&lang=js&"
import style0 from "./TableAutorizacionDeclaraciones.vue?vue&type=style&index=0&id=205f4100&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205f4100",
  null
  
)

export default component.exports